export default "/images/upload-cloud.svg?a94b24ba5b6a7231dce6185250df6bc1";